export const API_URL = process.env.REACT_APP_API_URL || 'invalid';
export const VERSION = process.env.REACT_APP_VERSION || 'unknown';
